export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_IS_ON_REPORTS = 'SET_IS_ON_REPORTS';

export const ADD_BOOKING = 'ADD_BOOKING';
export const GET_BOOKINGS = 'GET_BOOKINGS';
export const GET_BOOKING = 'GET_BOOKING';
export const REMOVE_BOOKING = 'REMOVE_BOOKING';
export const SEARCH_BOOKINGS = 'SEARCH_BOOKINGS';
export const FILTER_BOOKINGS = 'FILTER_BOOKINGS';

export const CLEAR_STATUS = 'CLEAR_STATUS';
export const SEARCH_BOOK_BY_TYPE = 'SEARCH_BOOK_BY_TYPE';
export const SEARCH_BOOK_BY_DATE_RANGE = 'SEARCH_BOOK_BY_DATE_RANGE';

export const SEARCH_BOOK_AMENITIES = 'SEARCH_BOOK_AMENITIES';
export const SEARCH_BOOK_PARKINGS = 'SEARCH_BOOK_PARKINGS';
export const SEARCH_BOOK_ELEVATOR = 'SEARCH_BOOK_ELEVATOR';
export const GET_PARKING_PAR_AM_BOOKINGS = 'GET_PARKING_PAR_AM_BOOKINGS';

export const GET_SELECTED_BOOKINGS = 'GET_SELECTED_BOOKINGS';
export const GET_BOOKINGS_LIST_V3 = 'GET_BOOKINGS_LIST_V3';
export const GET_BOOKINGS_CALENDAR_V3 = 'GET_BOOKINGS_CALENDAR_V3';
export const GET_BOOKING_V3 = 'GET_BOOKING_V3';
export const SET_LAST_BOOKINGS_CALENDAR_V3_PARAMS = 'SET_LAST_BOOKINGS_CALENDAR_V3_PARAMS';

export const GET_AMENITY_PAR_AM_BOOKINGS = 'GET_AMENITY_PAR_AM_BOOKINGS';
export const GET_ELEVATOR_PAR_AM_BOOKINGS = 'GET_ELEVATOR_PAR_AM_BOOKINGS';
export const RESET_BOOKING_PAGINATION = 'RESET_BOOKING_PAGINATION';

export const SET_BOOKING_SEARCH = 'SET_BOOKING_SEARCH';
export const GET_PAR_AM_BOOKING = 'GET_PAR_AM_BOOKING';
export const EDIT_PAR_AM_BOOKING = 'EDIT_PAR_AM_BOOKING';
export const ADD_PAR_AM_BOOKING = 'ADD_PAR_AM_BOOKING';
export const ADD_BOOKING_V3 = 'ADD_BOOKING_V3';
export const EDIT_BOOKING_V3 = 'EDIT_BOOKING_V3';
export const EDITING_PAR_AM_BOOKING = 'EDITING_PAR_AM_BOOKING';
export const GET_AVAILABLE_TIME = 'GET_AVAILABLE_TIME';
export const GET_AMENITY_AVAILABILITY_V2 = 'GET_AMENITY_AVAILABILITY_V2';
export const CLEAR_AMENITY_AVAILABILITY_V2 = 'CLEAR_AMENITY_AVAILABILITY_V2';
export const GET_BOOKING_COST_BREAKDOWN = 'GET_BOOKING_COST_BREAKDOWN';
export const CLEAR_BOOKING_COST_BREAKDOWN = 'CLEAR_BOOKING_COST_BREAKDOWN';
export const SET_PARAM_ERROR = 'SET_PARAM_ERROR';
export const CANCEL_BOOKING = 'CANCEL_BOOKING';
export const CANCEL_BOOKING_V3 = 'CANCEL_BOOKING_V3';
export const CONFIRM_BOOKING_V3 = 'CONFIRM_BOOKING_V3';
export const BOOKING_FROM_AMENITY = 'BOOKING_FROM_AMENITY';
export const CLEAR_PAR_AM_BOOKING = 'CLEAR_PAR_AM_BOOKING';

//booking amenities
export const CREATE_AMENITY_BOOKING = 'CREATE_AMENITY_BOOKING';
export const EDITING_BOOKING = 'EDITING_BOOKING';
export const CANCEL_AMENITY_BOOKING = 'CANCEL_AMENITY_BOOKING';
export const EDIT_AMENITY_BOOKING = 'EDIT_AMENITY_BOOKING';
export const SHOW_EDIT_AMENITY_BOOKING_MODAL = 'SHOW_EDIT_AMENITY_BOOKING_MODAL';
export const SHOW_CANCEL_AMENITY_BOOKING_MODAL = 'SHOW_CANCEL_AMENITY_BOOKING_MODAL';
export const ALL_AMENITY_BOOKINGS = 'ALL_AMENITY_BOOKINGS';
export const GET_AMENITY_TYPES = 'GET_AMENITY_TYPES';
//booking amenities

//conversation sent actions
export const SET_DUPLICATE_TEMP_NAME = 'SET_DUPLICATE_TEMP_NAME';
export const CHANGE_SENT_PAGE = 'CHANGE_SENT_PAGE';
export const SHOW_MODAL_FOR_SEND_MESSAGE = 'SHOW_MODAL_FOR_SEND_MESSAGE';
export const SENT_MESSAGES = 'SENT_MESSAGES';
export const SENT_MESSAGE_DETAILS = 'SENT_MESSAGE_DETAILS';
export const GET_ALL_TEMPLATES_DATA = 'GET_ALL_TEMPLATES_DATA';
export const GET_CATEGORY_MAPPING = 'GET_CATEGORY_MAPPING';
export const GET_TEMPLATE = 'GET_TEMPLATE';
export const CHANGED_TEMPLATE_DATA = 'CHANGED_TEMPLATE_DATA';
export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_MESSAGE_BODY = 'GET_MESSAGE_BODY';
export const SET_RECIPIENTS_LENGTH = 'SET_RECIPIENTS_LENGTH';
export const SEND_DRAFT_TEMPLATE = 'SEND_DRAFT_TEMPLATE';

//conversation sent actions

//Modal Open Constant

export const SET_MODAL = 'SET_MODAL';
export const SET_MODAL_sTACK = 'SET_MODAL_sTACK';

//this will be used everywehre to get all the tempaltes.
export const ALL_TEMPLATES = 'ALL_TEMPLATES';

//conversation template actions
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const TEMPLATE_SELECTED = 'TEMPLATE_SELECTED';
export const TEMPLATE_DATA = 'TEMPLATE_DATA';
export const IS_MODAL_VISIBLE = 'IS_MODAL_VISIBLE';
export const EDIT_THIS_TEMPLATE = 'EDIT_THIS_TEMPLATE';
export const SHOW_MODAL_FOR_TEMPLATE = 'SHOW_MODAL_FOR_TEMPLATE';
export const SEND_EMAIL = 'SEND_EMAIL';
export const SELECT_USER = 'SELECT_USER';
export const SET_TREE_DATA = 'SET_TREE_DATA';
export const SET_PARSED_TEMPLATE = 'SET_PARSED_TEMPLATE';
export const SEND_TEMPLATE = 'SEND_TEMPLATE';
export const CLEAR_TREE = 'CLEAR_TREE';
export const SET_TEMPLATE_DATA = 'SET_TEMPLATE_DATA';
export const CHANGE_SHOW_BUTTON = 'CHANGE_SHOW_BUTTON';
export const SEND_TEMPLATE_IMAGE = 'SEND_TEMPLATE_IMAGE';
export const SET_SELECTIION_TEXT = 'SET_SELECTIION_TEXT';
export const SET_PINNED_NEWS = 'SET_PINNED_NEWS';
export const SET_TITLE = 'SET_TITLE';
export const SET_FROM_TEAM = 'SET_FROM_TEAM';
export const SET_MEDIA = 'SET_MEDIA';
export const SET_IS_FETCHING_TEMPLATES = 'SET_IS_FETCHING_TEMPLATES';
export const SET_SELECT_USER_HELPERS = 'SET_SELECT_USER_HELPERS';
export const GET_DRAFT_DETAILS = 'GET_DRAFT_DETAILS';
export const UPDATE_DRAFT_DETAILS = 'UPDATE_DRAFT_DETAILS';
export const DELETE_DRAFT = 'DELETE_DRAFT';
export const RESET_DRAFT_DETAILS = 'RESET_DRAFT_DETAILS';

//conversation template actions
export const ADD_SERVICE_REQUEST_CACHE_USER = 'ADD_SERVICE_REQUEST_CACHE_USER';
export const INVITE_USER = 'INVITE_USER';
export const ADD_USER = 'ADD_USER';
export const ADD_USERS_FROM_CSV = 'ADD_USERS_FROM_CSV';
export const CLEAR_USER = 'CLEAR_USER';
export const EDIT_USER = 'EDIT_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const GET_USER = 'GET_USER';
export const SEARCH_USERS = 'SEARCH_USERS';
export const BUILDING_USERS = 'BUILDING_USERS';
export const SET_USER_AVATAR = 'SET_USER_AVATAR';
export const SET_USER = 'SET_USER';
export const SET_USERS_FROM_CSV = 'SET_USERS_FROM_CSV';
export const CLEAR_USERS_FROM_CSV = 'CLEAR_USERS_FROM_CSV';
export const SET_USERS_CSV_FILE = 'SET_USERS_CSV_FILE';
export const CLEAR_USERS_CSV_FILE = 'CLEAR_USERS_CSV_FILE';
export const CLEAR_AVATAR = 'CLEAR_AVATAR';
export const GET_USER_DEVICE_SLOTS = 'GET_USER_DEVICE_SLOTS';
export const SET_USER_DEVICE_SLOTS = 'SET_USER_DEVICE_SLOTS';
export const SET_USERS_ACTIVATED = 'SET_USERS_ACTIVATED';
export const SET_USER_SEARCH = 'SET_USER_SEARCH';
export const RESET_USER_PAGINATION = 'RESET_USER_PAGINATION';
export const SYNC_YARDI_USERS = 'SYNC_YARDI_USERS';
export const NOTIFY_UNIT_PIN = 'NOTIFY_UNIT_PIN';
export const SEND_USER_UNIT_PIN = 'SEND_USER_UNIT_PIN';
export const SET_UNITS_CSV_FILE = 'SET_UNITS_CSV_FILE';
export const CLEAR_UNITS_CSV_FILE = 'CLEAR_UNITS_CSV_FILE';
export const ADD_UNITS_FROM_CSV = 'ADD_UNITS_FROM_CSV';
export const SET_UNIT_PAGINATION = 'SET_UNIT_PAGINATION';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_CONFLICTING_DATES = 'GET_CONFLICTING_DATES';
export const CLEAR_CONFLICTING_DATES_DATA = 'CLEAR_CONFLICTING_DATES_DATA';
export const GET_RESERVATIONS = 'GET_RESERVATIONS';
export const CLEAR_RESERVATIONS = 'CLEAR_RESERVATIONS';
export const REACTIVATE_USER = 'REACTIVATE_USER';
export const UPDATE_VENDOR_ACCESS_CONTROL = 'UPDATE_VENDOR_ACCESS_CONTROL';
export const ISSUE_CREDENTIALS = 'ISSUE_CREDENTIALS';
export const GET_CREDENTIALS_COUNT = 'GET_CREDENTIALS_COUNT';

export const SET_ORG_ID = 'SET_ORG_ID';
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION';
export const EDIT_ORGANIZATION = 'EDIT_ORGANIZATION';
export const REMOVE_ORGANIZATION = 'REMOVE_ORGANIZATION';
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const GET_ORGANIZATION = 'GET_ORGANIZATION';
export const GET_ORG_CONFIG = 'GET_ORG_CONFIG';
export const CLEAR_ORGANIZATION = 'CLEAR_ORGANIZATION';
export const GET_ALL_UNITS_IN_ORG = 'GET_ALL_UNITS_IN_ORG';
export const GET_PM_ANALYTICS = 'GET_PM_ANALYTICS';
export const GET_PM_ANALYTICS_PENDING = 'GET_PM_ANALYTICS_PENDING';
export const GET_PM_ACTIVITIES = 'GET_PM_ACTIVITIES';
export const GET_PM_ACTIVITIES_PENDING = 'GET_PM_ACTIVITIES_PENDING';
export const SET_PM_DETAILS = 'SET_PM_DETAILS';

export const GET_ALL_ORGANIZATIONS = 'GET_ALL_ORGANIZATIONS';
export const SET_ALL_ORG_STATUS = 'SET_ALL_ORG_STATUS';

export const SEARCH_ORGANIZATIONS = 'SEARCH_ORGANIZATIONS';
export const SET_GLOBAL_ORG_ID = 'SET_GLOBAL_ORG_ID';
export const SET_GLOBAL_ORG = 'SET_GLOBAL_ORG';
export const UPLOAD_ORG_LOGO = 'UPLOAD_ORG_LOGO';

export const SEARCH_BUSINESSES = 'SEARCH_BUSINESSES';
export const ADD_BUSINESS = 'ADD_BUSINESS';
export const REMOVE_BUSINESS = 'REMOVE_BUSINESS';
export const EDIT_BUSINESS = 'EDIT_BUSINESS';
export const BUSINESS_SELECTED = 'BUSINESS_SELECTED';
export const GET_BUSINESS = 'GET_BUSINESS';
export const GET_BUSINESSES = 'GET_BUSINESSES';
export const SET_BUSINESSES_LOGO = 'SET_BUSINESSES_LOGO';
export const UN_SET_BUSINESSES_LOGO = 'UN_SET_BUSINESSES_LOGO';
export const CLEAR_BUSINESS = 'CLEAR_BUSINESS';

export const SEARCH_BUILDINGS = 'SEARCH_BUILDINGS';
export const ADD_BUILDING = 'ADD_BUILDING';
export const SET_BUILDING_IMAGE = 'SET_BUILDING_IMAGE';
export const GET_BUILDING_UNITS = 'GET_BUILDING_UNITS';
export const GET_BUILDING_DEVICES = 'GET_BUILDING_DEVICES';
export const SET_GLOBAL_BUILDING = 'SET_GLOBAL_BUILDING';
export const SET_GLOBAL_SELECTED_BUILDING = 'SET_GLOBAL_SELECTED_BUILDING';
export const GET_BUILDING_SUITES = 'GET_BUILDING_SUITES';
export const GET_ORG_BUILDING_SUITES = 'GET_ORG_BUILDING_SUITES';
export const SET_GLOBAL_BUILDING_ID = 'SET_GLOBAL_BUILDING_ID';
export const EDIT_BUILDING = 'EDIT_BUILDING';
export const CLEAR_BUILDING = 'CLEAR_BUILDING';
export const SET_BUILDING = 'SET_BUILDING';
export const SET_NEW_BUILDING = 'SET_NEW_BUILDING';
export const CLEAR_NEW_BUILDING = 'CLEAR_NEW_BUILDING';
export const REMOVE_BUILDING = 'REMOVE_BUILDING';
export const GET_BUILDING = 'GET_BUILDING';
export const GET_EDITED_BUILDINGS = 'GET_EDITED_BUILDINGS';
export const GET_BUILDINGS = 'GET_BUILDINGS';
export const GET_ALL_BUILDINGS = 'GET_ALL_BUILDINGS';
export const SET_CACHED_BUILDINGS = 'SET_CACHED_BUILDINGS';
export const SET_LOADING_CACHED_BUILDINGS = 'SET_LOADING_CACHED_BUILDINGS';
export const GET_BUILDING_LOCKS = 'GET_BUILDING_LOCKS';

export const SET_ALL_BUILDINGS = 'SET_ALL_BUILDINGS';
export const INCREMENT_BUILDING_EVENT_COUNT = 'INCREMENT_BUILDING_EVENT_COUNT';
export const RESET_GLOBAL_BUILDINGS = 'RESET_GLOBAL_BUILDINGS';
export const SET_GLOBAL_BUILDING_STATUS = 'SET_GLOBAL_BUILDING_STATUS';

export const SET_BUILDING_AVATAR = 'SET_BUILDING_AVATAR';

export const GET_DD_UNITS = 'GET_DD_UNITS';
export const CLEAR_UNIT_CREATION_RESPONSE = 'CLEAR_UNIT_CREATION_RESPONSE';
export const SET_UNIT_DATA = 'SET_UNIT_DATA';
export const ADD_UNIT = 'ADD_UNIT';
export const GET_DOOR_PIN = 'GET_DOOR_PIN';
export const GET_PIN_HISTORY = 'GET_PIN_HISTORY';
export const EDIT_UNIT = 'EDIT_UNIT';
export const REMOVE_UNIT = 'REMOVE_UNIT';
export const GET_UNIT = 'GET_UNIT';
export const GET_UNIT_RESIDENTS = 'GET_UNIT_RESIDENTS';
export const GET_SUITE = 'GET_SUITE';
export const GET_UNITS = 'GET_UNITS';
export const FILTER_UNITS = 'FILTER_UNITS';
export const CLEAR_BUILDINGS = 'CLEAR_BUILDINGS';

export const SET_AMENITY_TYPE = 'SET_AMENITY_TYPE';
export const GET_AMENITY = 'GET_AMENITY';
export const GET_AMENITY_V2 = 'GET_AMENITY_V2';
export const REMOVE_AMENITY = 'REMOVE_AMENITY';
export const GET_AMENITIES = 'GET_AMENITIES';
export const GET_BUILDING_AMENITIES_V2 = 'GET_BUILDING_AMENITIES_V2';
export const ADD_AMENITIES = 'ADD_AMENITIES';
export const ADD_AMENITIES_V2 = 'ADD_AMENITIES_V2';
export const UPDATE_AMENITY_V2 = 'UPDATE_AMENITY_V2';
export const UPLOAD_AMENITY_WAIVER_DOC = 'UPLOAD_AMENITY_WAIVER_DOC';
export const UPLOAD_AMENITY_IMAGES_BATCH_V2 = 'UPLOAD_AMENITY_IMAGES_BATCH_V2';
export const SYNC_AMENITY_IMAGES_V2 = 'SYNC_AMENITY_IMAGES_V2';
export const EDIT_AMENITIES = 'EDIT_AMENITIES';
export const CLEAR_AMENITY = 'CLEAR_AMENITY';
export const FILTER_AMENITIES = 'FILTER_AMENITIES';
export const MODAL_SHOW_AMENITY_DETAIL = 'MODAL_SHOW_AMENITY_DETAIL';
export const SET_FILTERED_AMENITIES = 'SET_FILTERED_AMENITIES';
export const CLEAR_FILTERED_AMENITIES = 'CLEAR_FILTERED_AMENITIES';
export const CLEAR_AMENITIES = 'CLEAR_AMENITIES';

export const ADD_AVATAR = 'ADD_AVATAR';
export const EDIT_AVATAR = 'EDIT_AVATAR';
export const GET_AVATAR = 'GET_AVATAR';

export const SET_IS_ON_DASHBOARD = 'SET_IS_ON_DASHBOARD';
export const SET_TOAST = 'SET_TOAST';
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const SET_SIDEBAR_TYPE = 'SET_SIDEBAR_TYPE';
export const SET_ASIDE = 'SET_ASIDE';
export const SET_MODE = 'SET_MODE';

export const GET_SERVICES = 'GET_SERVICES';
export const GET_SERVICE_COMMENTS = 'GET_SERVICES_COMMENTS';
export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const CREATE_SERVICE = 'CREATE_SERVICE';
export const UPLOAD_SERVICE_IMAGE = 'UPLOAD_SERVICE_IMAGE';
export const GET_SERVICE = 'GET_SERVICE';
export const SET_SERVICE_SEARCH = 'SET_SERVICE_SEARCH';
export const CLEAR_SERVICE = 'CLEAR_SERVICE';
export const ADD_COMMENT = 'ADD_COMMENT';
export const GET_COMMENT_ID = 'GET_COMMENT_ID';
export const ADD_COMMENT_DYNAMIC = 'ADD_COMMENT_DYNAMIC';
export const FILTER_SERVICES = 'FILTER_SERVICES';
export const SERVICE_CATEGORY = 'SERVICE_CATEGORY';
export const GET_SERVICE_CATEGORIES = 'GET_SERVICE_CATEGORIES';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const COMPLETE_SERVICE = 'COMPLETE_SERVICE';
export const SET_ASSIGNED_OPERATOR_PROCESS = 'SET_ASSIGNED_OPERATOR_PROCESS';
export const RESET_SERVICE_PAGINATION = 'RESET_SERVICE_PAGINATION';
export const CLEAR_SERVICE_LIST = 'CLEAR_SERVICE_LIST';
export const SET_SERVICE_STATUS_FILTER = 'SET_SERVICE_STATUS_FILTER';
export const SYNC_YARDI_REQUESTS = 'SYNC_YARDI_REQUESTS';
export const SYNC_YARDI_SUITES = 'SYNC_YARDI_SUITES';

export const SYNC_REQUEST = 'SYNC_REQUEST';

export const SET_CURRENT_AMENITY_TYPE = 'SET_CURRENT_AMENITY_TYPE';

export const OPEN_CHAT_MODAL = 'OPEN_CHAT_MODAL';
export const CLOSE_CHAT_MODAL = 'CLOSE_CHAT_MODAL';

export const GET_PROFILE = 'GET_PROFILE';
export const GET_SETTINGS = 'GET_SETTINGS';
export const SET_PREVIOUS_PROFILE_IMG = 'SET_PREVIOUS_PROFILE_IMG';
export const GET_PROFILE_AVATAR = 'GET_PROFILE_AVATAR';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const UPLOAD_PROFILE_AVATAR = 'UPLOAD_PROFILE_AVATAR';

export const LOG_IN = 'LOG_IN';
export const LOG_IN_SSO = 'LOG_IN_SSO';
export const GET_SSO_ORGANIZATIONS = 'GET_SSO_ORGANIZATIONS';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const SET_EMAIL = 'SET_EMAIL';
export const LOG_OUT = 'LOG_OUT';
export const FETCH_REFRESH_TOKEN = 'FETCH_REFRESH_TOKEN';
export const CHANGE_LOGIN_PAGE = 'CHANGE_LOGIN_PAGE';
export const VERIFY_ACCOUNT = 'VERIFY_ACCOUNT';
export const CONFIRM_OTP = 'CONFIRM_OTP';
export const SET_LOGIN_TRUE = 'SET_LOGIN_TRUE';
export const SET_LOGIN_FALSE = 'SET_LOGIN_FALSE';
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';

export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const SET_ID_TOKEN = 'SET_ID_TOKEN';
export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
export const SET_ROLE_ID = 'SET_ROLE_ID';

export const GET_COUNTRY = 'GET_COUNTRY';
export const GET_STATE = 'GET_STATE';
export const CLEAR_COUNTRY = 'CLEAR_COUNTRY';
export const SET_PROJECT = 'SET_PROJECT';
export const CLEAR_PROJECT = 'CLEAR_PROJECT';

// offers
export const SET_OFFER_TREE_DATA = 'SET_OFFER_TREE_DATA';

export const SET_IS_EDITING = 'SET_IS_EDITING';
export const ADD_OFFER = 'ADD_OFFER';
export const SET_OFFER_TEMP = 'SET_OFFER_TEMP';
export const SET_OFFER_PAGE = 'SET_OFFER_PAGE';
export const CLEAR_LOGO = 'CLEAR_LOGO';
export const DELETE_OFFER = 'DELETE_OFFER';
export const ADD_LOGO = 'ADD_LOGO';
export const EDIT_OFFER = 'EDIT_OFFER';
export const GET_OFFERS = 'GET_OFFERS';
export const CLEAR_OFFER = 'CLEAR_OFFER';
export const GET_OFFER = 'GET_OFFER';
export const SEARCH_OFFERS = 'SEARCH_OFFERS';
export const GET_ACTIVE_OFFERS = 'GET_ACTIVE_OFFERS';
export const GET_EXPIRED_OFFERS = 'GET_EXPIRED_OFFERS';
export const GET_SUBMISSIONED_OFFERS = 'GET_SUBMISSIONED_OFFERS';
export const CHANGE_TAB = 'CHANGE_TAB';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';

export const GET_PAGED_NOTIF = 'GET_PAGED_NOTIF';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_REGISTRATION_TOKEN = 'SET_REGISTRATION_TOKEN';
export const MARK_NOTIFICATIONS_AS_READ = 'MARK_NOTIFICATIONS_AS_READ';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_NOTIF_PAGE = 'SET_NOTIF_PAGE';

export const REGISTER_FCM_TOKEN = 'REGISTER_FCM_TOKEN';
export const SET_FCM_TOKEN = 'SET_FCM_TOKEN';
export const UPDATE_MY_SETTINGS = 'UPDATE_MY_SETTINGS';

export const LOGGED_IN_USER_AVATAR = 'LOGGED_IN_USER_AVATAR';
export const NON_LOGGED_IN_USER_AVATAR = 'NON_LOGGED_IN_USER_AVATAR';
export const SET_LOGGED_IN_USER_AVATAR = 'SET_LOGGED_IN_USER_AVATAR';

//Reports
export const GET_LOGS = 'GET_LOGS';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_ACTIVATION_LOGS = 'GET_ACTIVATION_LOGS';
export const GET_REQUEST_TURN_AROUND_TIME = 'GET_REQUEST_TURN_AROUND_TIME';
export const SET_CSV_URL = 'SET_CSV_URL';
export const SET_CSV_FIELDS = 'SET_CSV_FIELDS';
export const GET_TOTAL_METRICS = 'GET_TOTAL_METRICS';
export const GET_DEALS_STATS = 'GET_DEALS_STATS';
export const GET_DEAL_STATS = 'GET_DEAL_STATS';
export const OPEN_DEAL_STATS_MODAL = 'OPEN_DEAL_STATS_MODAL';
export const CLOSE_REPORTS_MODAL = 'CLOSE_REPORTS_MODAL';

// Search
export const SEARCH = 'SEARCH';
export const FILTERS = 'FILTERS';
export const SET_SEARCH_FIELD = 'SET_SEARCH_FIELD';
export const SET_SHOULD_CLEAR_QUERY = 'SET_SHOULD_CLEAR_QUERY';

// TODO: Remove this in the future and move all filters under the filters object
export const SET_SEARCH_STATE = 'SET_SEARCH_STATE';
export const SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
export const REMOVE_SEARCH_FILTER = 'REMOVE_SEARCH_FILTER';
export const SET_SEARCH_COLUMN_FILTER = 'SET_SEARCH_COLUMN_FILTER';
export const SET_SEARCH_PAGINATION = 'SET_SEARCH_PAGINATION';
export const CLEAR_SEARCH_FILTER = 'CLEAR_SEARCH_FILTER';
export const RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER';

export const REQUEST_PERMISSION = 'REQUEST_PERMISSION';

// Email Selected
export const SELECT_EMAIL_RECIPIENT = 'SELECT_EMAIL_RECIPIENT';
export const RESET_EMAIL_RECIPIENT = 'RESET_EMAIL_RECIPIENT';
export const SEND_WELCOME_EMAILS = 'SEND_WELCOME_EMAILS';
export const SEND_WELCOME_EMAILS_NEW_USERS = 'SEND_WELCOME_EMAILS_NEW_USERS';
export const SELECT_ALL_RECIPIENTS = 'SELECT_ALL_RECIPIENTS';
export const REMOVE_SELECTED_RECIPIENTS = 'REMOVE_SELECTED_RECIPIENTS';

// Security
export const GET_COMMON_ACCESS = 'GET_COMMON_ACCESS';
export const SET_COMMON_ACCESS = 'SET_COMMON_ACCESS';
export const GET_BUILDING_CAMERAS = 'GET_BUILDING_CAMERAS';
export const GET_NVR_AVAILABLE = 'GET_NVR_AVAILABLE';
export const GET_USER_FAVORITE_CAMERAS = 'GET_USER_FAVORITE_CAMERAS';
export const ADD_USER_FAVORITE_CAMERA = 'ADD_USER_FAVORITE_CAMERA';
export const REMOVE_USER_FAVORITE_CAMERA = 'REMOVE_USER_FAVORITE_CAMERA';

// Global push notification to all users
export const SEND_ALL_USERS_NOTIFICATION = 'SEND_ALL_USERS_NOTIFICATION';

export const GET_DELIVERY_CODES = 'GET_DELIVERY_CODES';
export const ADD_DELIVERY_CODE = 'ADD_DELIVERY_CODE';
export const REMOVE_DELIVERY_CODE = 'REMOVE_DELIVERY_CODE';

export const SHOW_GLOBAL_BUILDINGS_DROPDOWN = 'SHOW_GLOBAL_BUILDINGS_DROPDOWN';

export const GET_DEVICES_FOR_SUITES = 'GET_DEVICES_FOR_SUITES';
export const ADD_NEW_SUITE = 'ADD_NEW_SUITE';
export const RESET_CSV_SUITES = 'RESET_CSV_SUITES';
export const SET_CSV_SUITES = 'SET_CSV_SUITES';
export const DELETE_A_SUITE = 'DELETE_A_SUITE';
export const GET_A_SUITE = 'GET_A_SUITE';
export const EDIT_A_SUITE = 'EDIT_A_SUITE';
export const RESET_SUITE_IN_BUILDING = 'RESET_SUITE_IN_BUILDING';
export const SET_SEARCH_TEXT_SUITE = 'SET_SEARCH_TEXT_SUITE';
export const REMOVE_SEARCH_TEXT_SUITE = 'REMOVE_SEARCH_TEXT_SUITE';

// Deliveries
export const CREATE_DELIVERY = 'CREATE_DELIVERY';
export const UPDATE_DELIVERY = 'UPDATE_DELIVERY';
export const CLEAR_DELIVERY = 'CLEAR_DELIVERY';
export const UPLOAD_DELIVERY_IMAGE = 'UPLOAD_DELIVERY_IMAGE';

// Bluebits
export const BLUEBITS_LOGIN = 'BLUEBITS_LOGIN';
export const BLUEBITS_GET_LOCKERS = 'BLUEBITS_GET_LOCKERS';
export const BLUEBITS_GET_LOCKER_SETTINGS = 'BLUEBITS_GET_LOCKER_SETTINGS';
export const BLUEBITS_GET_LOCKER_PARCELS = 'BLUEBITS_GET_LOCKER_PARCELS';
export const BLUEBITS_GET_LOCKER_NOTIFICATIONS = 'BLUEBITS_GET_LOCKER_NOTIFICATIONS';
export const BLUEMYTH_GET_LOCKERS_FOR_PORTAL = 'BLUEMYTH_GET_LOCKERS_FOR_PORTAL';
export const BLUEMYTH_LINK_LOCKERS = 'BLUEMYTH_LINK_LOCKERS';
export const BLUEBITS_CLEAR_STATE = 'BLUEBITS_CLEAR_STATE';

// Carriers
export const SET_CARRIERS = 'SET_CARRIERS';

// Thermostat
export const GET_THERMOSTATS = 'GET_THERMOSTATS';
export const GET_THERMOSTAT = 'GET_THERMOSTAT';
export const UPDATE_THERMOSTAT = 'UPDATE_THERMOSTAT';
export const UPDATE_THERMOSTAT_BULK = 'UPDATE_THERMOSTAT_BULK';
export const UPDATE_ECOBEE_THERMOSTAT = 'UPDATE_ECOBEE_THERMOSTAT';
export const UPDATE_DEMO_THERMOSTAT = 'UPDATE_DEMO_THERMOSTAT';
export const UPDATE_DEMO_THERMOSTAT_STATE = 'UPDATE_DEMO_THERMOSTAT_STATE';
export const UPDATE_THERMOSTAT_HVAC_MODE = 'UPDATE_THERMOSTAT_HVAC_MODE';
export const UPDATE_THERMOSTAT_HVAC_MODE_BULK = 'UPDATE_THERMOSTAT_HVAC_MODE_BULK';

// Building Thermostat Presets
export const GET_MASTER_THERMOSTAT_CONTROL = 'GET_MASTER_THERMOSTAT_CONTROL';
export const UPDATE_MASTER_THERMOSTAT_CONTROL = 'UPDATE_MASTER_THERMOSTAT_CONTROL';
export const GET_BUILDING_THERMOSTAT_PRESETS = 'GET_BUILDING_THERMOSTAT_PRESETS';
export const CREATE_THERMOSTAT_PRESET = 'CREATE_THERMOSTAT_PRESET';
export const UPDATE_BUILDING_THERMOSTAT_PRESETS = 'UPDATE_BUILDING_THERMOSTAT_PRESETS';
export const ATTACH_THERMOSTAT_PRESET = 'ATTACH_THERMOSTAT_PRESET';

// Leak Detector
export const ACKNOWLEDGE_LEAK_DETECTOR = 'ACKNOWLEDGE_LEAK_DETECTOR';
export const GET_LEAK_DETECTORS = 'GET_LEAK_DETECTORS';

// License Plates
export const GET_LICENSE_PLATE = 'GET_LICENSE_PLATE';
export const CREATE_LICENSE_PLATE = 'CREATE_LICENSE_PLATE';
export const UPDATE_LICENSE_PLATE = 'UPDATE_LICENSE_PLATE';
export const DELETE_LICENSE_PLATE = 'DELETE_LICENSE_PLATE';

// Intercom
export const GET_INTERCOM_UNIT_PINS = 'GET_INTERCOM_UNIT_PINS';
export const GET_GRATA_INTERCOM_USER = 'GET_GRATA_INTERCOM_USER';
export const UPDATE_INTERCOM_USER = 'UPDATE_INTERCOM_USER';
export const DELETE_INTERCOM_USER = 'DELETE_INTERCOM_USER';
export const SEARCH_INTERCOM_USERS = 'SEARCH_INTERCOM_USERS';
export const CLEAR_INTERCOM_USERS = 'CLEAR_INTERCOM_USERS';
export const PUSH_RESIDENTS_TO_INTERCOM = 'PUSH_RESIDENTS_TO_INTERCOM';

export const UPDATE_INTERCOM_USERS_CACHE = 'UPDATE_INTERCOM_USERS_CACHE';
export const DELETE_INTERCOM_USER_FROM_CACHE = 'DELETE_INTERCOM_USER_FROM_CACHE';

// Demo
export const UPDATE_PAYMENT_DATA = 'UPDATE_PAYMENT_DATA';
export const CLEAR_PAYMENT_DATA = 'CLEAR_PAYMENT_DATA';
export const CLEAR_USER_PAYMENT_DATA = 'CLEAR_USER_PAYMENT_DATA';

export const GET_ORGANIZATION_ONBOARDING_STATUS = 'GET_ORGANIZATION_ONBOARDING_STATUS';
export const GET_BUILDING_ONBOARDING_STATUS = 'GET_BUILDING_ONBOARDING_STATUS';

export const GET_VOPAY_USER = 'GET_VOPAY_USER';
export const GET_VOPAY_USER_PAYMENT_METHODS = 'GET_VOPAY_USER_PAYMENT_METHODS';
export const GET_BUILDING_PAYMENT_STATS = 'GET_BUILDING_PAYMENT_STATS';

export const GET_PAYMENT_USER = 'GET_PAYMENT_USER';
export const CREATE_RESIDENT_VOPAY_ACCOUNT = 'CREATE_RESIDENT_VOPAY_ACCOUNT';
export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD';
export const SYNC_PAYMENT_METHOD = 'SYNC_PAYMENT_METHOD';

/** VoPay add-payment-method API: `paymentMethodType` value for bank (EFT) setup. */
export const PAYMENT_METHOD_TYPE_BANK = 'bank';

export const FUND_TRANSFER_WITHDRAW = 'FUND_TRANSFER_WITHDRAW';
export const FUND_TRANSFER_WITHDRAW_SCHEDULE = 'FUND_TRANSFER_WITHDRAW_SCHEDULE';
export const CANCEL_SCHEDULED_TRANSFER = 'CANCEL_SCHEDULED_TRANSFER';
export const REFUND_VOPAY_PAYMENT = 'REFUND_VOPAY_PAYMENT';

// Documents
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const GET_DOCUMENT = 'GET_DOCUMENT';
export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_PROGRESS = 'UPLOAD_DOCUMENT_PROGRESS';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const GET_FOLDER_DOCUMENTS = 'GET_FOLDER_DOCUMENTS';
export const GET_FOLDER_OPTIONS = 'GET_FOLDER_OPTIONS';
export const CREATE_FOLDER = 'CREATE_FOLDER';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';
export const DELETE_FOLDER = 'DELETE_FOLDER';
export const MOVE_DOCUMENT = 'MOVE_DOCUMENT';

export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENT = 'GET_EVENT';
export const ADD_EVENT = 'ADD_EVENT';
export const EDIT_EVENT = 'EDIT_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const NOTIFY_EVENT = 'NOTIFY_EVENT';
export const UPLOAD_EVENT_IMAGE = 'UPLOAD_EVENT_IMAGE';
export const DELETE_EVENT_IMAGE = 'DELETE_EVENT_IMAGE';
export const UPLOAD_EVENT_IMAGES_BATCH = 'UPLOAD_EVENT_IMAGES_BATCH';
export const SYNC_EVENT_IMAGES = 'SYNC_EVENT_IMAGES';

// Chat
export const GET_CHAT_CONVERSATIONS = 'GET_CHAT_CONVERSATIONS';
export const GET_CHAT_MESSAGES = 'GET_CHAT_MESSAGES';
export const MARK_CHAT_CONVERSATION_READ = 'MARK_CHAT_CONVERSATION_READ';
export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';
export const CREATE_CHAT_DIRECT = 'CREATE_CHAT_DIRECT';
export const SELECT_CHAT_CONVERSATION = 'SELECT_CHAT_CONVERSATION';
export const CLEAR_CHAT_THREAD = 'CLEAR_CHAT_THREAD';
export const APPLY_CHAT_REALTIME_MESSAGE = 'APPLY_CHAT_REALTIME_MESSAGE';
export const SET_CHAT_HAS_UNREAD = 'SET_CHAT_HAS_UNREAD';
export const GET_CHAT_UNREAD = 'GET_CHAT_UNREAD';
